import React, { memo } from "react";
import InfoIcon from "./images/icons/info.svg?react";
import "./InfoMessage.scss";

interface IInfoMessage {
  children: React.ReactNode;
}

export const InfoMessage: React.FC<IInfoMessage> = memo(({ children }) => {
  return (
    <div className="InfoMessage">
      <span><InfoIcon /></span>
      {children}
    </div>
  );
});
